import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createElementVNode as _createElementVNode, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "reactions__modal" }
const _hoisted_2 = { class: "reactions-list__navigation" }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { class: "reactions-list__scrollable" }
const _hoisted_5 = { class: "reactions-item__name" }
const _hoisted_6 = { class: "reactions-item__emojis" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_IconHeartOutline = _resolveComponent("IconHeartOutline")
  const _component_NcButton = _resolveComponent("NcButton")
  const _component_AvatarWrapper = _resolveComponent("AvatarWrapper")
  const _component_NcLoadingIcon = _resolveComponent("NcLoadingIcon")
  const _component_NcDialog = _resolveComponent("NcDialog")

  return (_openBlock(), _createBlock(_component_NcDialog, {
    name: $options.t('spreed', 'Reactions'),
    "close-on-click-outside": "",
    "onUpdate:open": $options.closeModal
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (Object.keys($options.reactionsOverview).length > 0)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createElementVNode("div", _hoisted_2, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.reactionsMenu, (reaction) => {
                  return (_openBlock(), _createBlock(_component_NcButton, {
                    key: reaction,
                    class: _normalizeClass({ active: $data.reactionFilter === reaction, 'all-reactions__button': reaction === '♡' }),
                    variant: "tertiary",
                    onClick: $event => ($options.handleTabClick(reaction))
                  }, {
                    default: _withCtx(() => [
                      (reaction === '♡')
                        ? (_openBlock(), _createBlock(_component_IconHeartOutline, {
                            key: 0,
                            size: 15
                          }))
                        : (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(reaction), 1)),
                      _createTextVNode(" " + _toDisplayString($options.reactionsOverview[reaction].length), 1)
                    ]),
                    _: 2
                  }, 1032, ["class", "onClick"]))
                }), 128))
              ]),
              _createElementVNode("ul", _hoisted_4, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.reactionsOverview[$data.reactionFilter], (item) => {
                  return (_openBlock(), _createElementBlock("li", {
                    key: item.actorId + item.actorType,
                    class: "reactions-item"
                  }, [
                    _createVNode(_component_AvatarWrapper, {
                      id: item.actorId,
                      token: $props.token,
                      name: item.actorDisplayName,
                      source: item.actorType,
                      size: $setup.AVATAR.SIZE.SMALL,
                      "disable-menu": ""
                    }, null, 8, ["id", "token", "name", "source", "size"]),
                    _createElementVNode("span", _hoisted_5, _toDisplayString(item.actorDisplayNameWithFallback), 1),
                    _createElementVNode("span", _hoisted_6, _toDisplayString(item.reaction?.join('') ?? $data.reactionFilter), 1)
                  ]))
                }), 128))
              ])
            ], 64))
          : (_openBlock(), _createBlock(_component_NcLoadingIcon, {
              key: 1,
              size: 64
            }))
      ])
    ]),
    _: 1
  }, 8, ["name", "onUpdate:open"]))
}